// App.jsx
import React, { useState } from "react";
import './index.scss'
import { stopLoading } from "../../../../action/huntPlanner-load-spinner-action";
import { connect } from 'react-redux'

function TableView(props) {
  let [raisedOdds, setRaisedOdds] = useState({})
  const [percentageValue, setPercentageValue] = useState(100)
  let tableData = props.tableData
  let from = props.from
  const firstRaisedOdds = tableData.find(item => item.odds > 0);
  if (firstRaisedOdds) {
    // setRaisedOdds(firstRaisedOdds)
    console.log("First raised odds:", firstRaisedOdds);
  } else {
    console.log("No raised odds found.");
  }
  return (
    <div className="ht-table-container">


      <table className="custom-table">
        <thead>
          <tr>
            {
              from == 'filter' ?
                tableData.map((point, index) => {
                  return (
                    <th key={index}
                      className={`${!props.ExactPoints ? (+props.DrawPoints >= +point ? 'dark' : '') : props.ExactPoints && (+props.DrawPoints == +point) && 'dark'}`}
                    >{point}</th>
                  )
                }
                ) :
                tableData.map((data, index) => (
                  <th key={index}
                    className={`${+props?.huntplannerMorefilters?.DrawPoints == data.point ? "dark" : !+props?.huntplannerMorefilters?.DrawPoints && data.point == 0 ? 'dark' : ''} }`}
                  >{data.point}</th>
                ))
            }
          </tr>
        </thead>
        <tbody>
          <tr>
            {
              from == 'filter' ?
                tableData.map((point, index) => (
                  <td
                    key={index}
                    className={`${!props.ExactPoints ? (+point <= +props.DrawPoints ? 'highlighted' : '') : props.ExactPoints && (+props.DrawPoints == +point) && 'highlighted'}`}
                  >
                    {props.DrawPoints == point ? props.DrawPercentage == 0 ? 'Any' : props.DrawPercentage + "%" : percentageValue + '%'}
                  </td>
                ))
                :
                tableData.map((data, index) => (
                  <td
                    style={{
                      backgroundColor:
                        +props?.huntplannerMorefilters?.DrawPoints == data.point && +props?.huntplannerMorefilters?.DrawPercentage ?
                          (+props?.huntplannerMorefilters?.DrawPercentage < 33 ? '#B2001E' : +props?.huntplannerMorefilters?.DrawPercentage < 66 ? '#D8C305' : '#589500')
                          :
                          +props?.huntplannerMorefilters?.DrawPoints == data.point && (data.odds < 33 ? '#B2001E' : data.odds < 66 ? '#D8C305' : ' #589500')
                    }}
                    key={index}
                    className={`${+props?.huntplannerMorefilters?.DrawPoints == data.point ? "highlighted" : !+props?.huntplannerMorefilters?.DrawPoints && data.point == 0 ? (data.odds < 33 ? 'highlighted-red' : data.odds < 66 ? 'highlighted-yellow' : ' highlighted') : ''}`}
                  >
                    {/* {+props?.huntplannerMorefilters?.DrawPoints == data.point && +props?.huntplannerMorefilters?.DrawPercentage ? +props?.huntplannerMorefilters?.DrawPercentage : data.odds && data.odds.toFixed(0)}% */}
                    {data.odds.toFixed(0) + '%'}
                  </td>
                ))
            }
          </tr>
        </tbody>
      </table>
    </div >
  );
}

const mapStateToProps = state => ({
  huntplannerMorefilters: state.huntplannerMorefilters

})

const mapDispatchToProps = dispatch => ({
  stopLoading: () => dispatch(stopLoading()),
})

export default connect(mapStateToProps, mapDispatchToProps)(TableView)